export enum LangKey {
  en = 'en',
  ru = 'ru',
}

export enum LangNativeName {
  en = 'english',
  ru = 'russian',
}
